import { withFormsy, propTypes } from 'formsy-react';
import React, { PureComponent } from 'react';
import AsyncSelect from 'react-select/async-creatable';
import { components } from 'react-select';
import { Row, Col } from 'reactstrap';
import qs from 'qs';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { WriteCustomerModalForm } from 'components/action-forms/supplier-customer/WriteCustomerModalForm';
import getAxiosInstance from 'app/config/api';
import CustomerTypeIcon from '../CustomerTypeIcon';

import lodashUUID from 'lodash-uuid';
_.mixin(lodashUUID);

let cancelTokenSource = null;

/* eslint-disable */
const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <table className="table w-100 mt-n1">
        <caption>
          Lista med sökresultat,{' '}
          {props.options.length === 0
            ? 'sökningen gav inget resultat'
            : 'skriv för att söka efter fler.'}
        </caption>
        <thead className="table-light">
          <tr>
            <th className="text-nowrap text-center w-100 py-1">Företagsnamn</th>
            <th className="text-nowrap text-center w-100 py-1">
              Organisationsnummer
            </th>
            <th className="text-nowrap text-center w-100 py-1">Namn</th>
            <th className="text-nowrap text-center w-100 py-1">Adress</th>
            <th className="text-nowrap text-center w-100 py-1">Stad</th>
            <th className="text-nowrap text-center w-100 py-1">Kundnummer</th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  if (props.data.label) {
    return (
      <tr>
        <td colSpan="10">
          <components.Option {...props} />
        </td>
      </tr>
    );
  }
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={
        (props.isSelected ? 'table-active' : '') +
        (props.isFocused ? ' bg-light' : '') +
        ' select-option'
      }
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      <td className="text-nowrap py-1">{props.data.name}</td>
      <td className="text-nowrap py-1">{props.data.organisationNumber}</td>
      <td className="text-nowrap py-1">{props.data.deliveryName}</td>
      <td className="text-nowrap py-1">{props.data.deliveryAddress}</td>
      <td className="text-nowrap py-1">{props.data.deliveryCity}</td>
      <td className="text-nowrap py-1">{props.data.customerNumber}</td>
    </tr>
  );
};

function withFormsyValidations(
  WrappedComponent,
  validations,
  validationErrors,
) {
  const FormsyfiedComponent = withFormsy(WrappedComponent);

  return props => (
    <FormsyfiedComponent
      validations={validations ? validations(props) : undefined}
      validationErrors={validationErrors}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      value={_.get(props, 'value.id')}
      customer={props.value}
    />
  );
}

const ValueContainer = ({ children, selectProps, ...restOfProps }) => {
  const entity = selectProps.value || {};

  const { deliveryAddress, deliveryCity, id, name, customerNumber } = entity;
  return (
    <>
      <Row style={{ width: '95%' }}>
        <Col className=" mt-1 mx-1">
          <CustomerTypeIcon entity={entity} />
          <Row style={{ marginLeft: '70px', marginTop: '-70px' }}>
            <Col xs={12} className="ms-2 ms-sm-0">
              <Row>
                <Col className="mt-sm-2">
                  <h5 className="mb-0">
                    <components.ValueContainer
                      {...{ ...restOfProps, selectProps }}
                      className="ps-0"
                    >
                      {children}
                    </components.ValueContainer>
                  </h5>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={10} sm={7}>
                  <span className="text-nowrap">
                    {[deliveryAddress, deliveryCity].filter(x => x).join(', ')}
                    &nbsp;
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
/* eslint-enable */

class SupplierCustomerSelect extends PureComponent {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      supplierCustomer: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      isDisabled: false,
      supplierCustomer: undefined,
    };
  }

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.state = {
      value: props.value,
    };
    this.selectHandler = this.selectHandler.bind(this);
    this.showModalOnCreate = this.showModalOnCreate.bind(this);
    this.createModal = React.createRef();
  }

  async search(inputValue) {
    const { supplierCustomer } = this.props;
    const query = {
      active: true,
      or: [
        { name: { iLike: `%${inputValue}%` } },
        { deliveryName: { iLike: `%${inputValue}%` } },
        { customerNumber: { iLike: `%${inputValue}%` } },
        { organisationNumber: { iLike: `%${inputValue}%` } },
        { deliveryCity: { iLike: `%${inputValue}%` } },
        { deliveryAddress: { iLike: `%${inputValue}%` } },
      ],
    };

    const queryStr = qs.stringify({
      query,
      supplierCustomer: _.get(supplierCustomer, 'id'),
      cacheBuster: new Date().getTime(),
    });
    const requestUrl = `/supplierCustomers/?${queryStr}`;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();
    const response = await getAxiosInstance().get(`${requestUrl}`, {
      cancelToken: cancelTokenSource.token,
    });

    cancelTokenSource = null;
    return response.data.rows;
  }

  async selectHandler(selectedEntity) {
    const { onChange, name, setValue, value } = this.props;
    if (selectedEntity.id !== value?.id) {
      const requestUrl = `/supplierCustomers/${selectedEntity.id}`;
      const response = await getAxiosInstance().get(requestUrl);
      const fullEntity = response.data;
      await onChange(name, fullEntity);
      // This is because some rerender chananigans cause the form to not be updated if no time out
      await setTimeout(() => {
        setValue(fullEntity);
      }, 5);
    }
  }

  handleChange = newValue => {
    this.props.setValue(newValue);
  };

  showModalOnCreate() {
    this.createModal.current.toggle();
  }

  render() {
    const { name, customer, fallbackEntity, isDisabled, isValid } = this.props;

    return (
      <>
        <div className="d-none">
          <WriteCustomerModalForm
            ref={this.createModal}
            onSubmit={this.selectHandler}
            entity={{
              ...fallbackEntity,
              id: _.uuid(),
              customerNumber: undefined,
            }}
          />
        </div>
        <AsyncSelect
          id={_.uniqueId('supplierCustomer-select')}
          defaultOptions
          cacheOptions
          instanceId={`select-${name}`}
          className={!isValid ? 'border border-danger' : ''}
          name={name}
          value={customer}
          components={{ ValueContainer, MenuList, Option }}
          isDisabled={isDisabled}
          loadOptions={this.search}
          placeholder="Sök eller skapa kund..."
          getOptionValue={option => option.id}
          getOptionLabel={option => {
            if (option.value) {
              return (
                <span className="fw-bold">
                  Kund ej hittad. Vill du skapa ett kundkort för {option.value}?
                </span>
              );
            }
            return [
              option.customerNumber,
              option.name,
              option.organisationNumber,
              option.deliveryName,
              option.deliveryAddress,
              option.deliveryCity,
            ]
              .filter(x => x)
              .join(' - ');
          }}
          onChange={this.selectHandler}
          createOptionPosition="first"
          isValidNewOption={(inputValue, selectValue, selectOptions) =>
            selectOptions.length === 0
          }
          onCreateOption={this.showModalOnCreate}
          styles={{
            // Fixes the overlapping problem of the component
            menu: provided => ({
              ...provided,
              zIndex: 9999,
              position: 'relative',
            }),
          }}
        />
      </>
    );
  }
}

export default withFormsyValidations(SupplierCustomerSelect, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value;
    }
    return true;
  },
}));
